// PAGO UNIFICADO - Guard de acceso para pantalla Registro de Pago Unificado - 01/10/2026
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
@Injectable()
export class PagosUnificadoGuard implements CanActivate {
    tieneacceso = false;
    options: any[] = [];
  constructor(
    public router: Router
  ) {}
  canActivate() {
    this.options = JSON.parse(localStorage.getItem('dataacc'));
    if ( this.options.includes(btoa('/pagos/unificado')) ) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
